import { createStyles, Typography } from '@material-ui/core'
import { WithStyles, withStyles } from '@material-ui/core/styles'
import React from 'react'

const styles = () => {
  createStyles({
    tooltipContent: {
      fontSize: '1.05em',
    },
  })
}

export const MapToolTip = withStyles(styles)(
  ({
    title,
    children,
    classes,
  }: {
    children?: React.ReactNode
    title?: string
  } & WithStyles) => {
    return (
      <>
        {title && (
          <Typography component={'div'} variant="h6" noWrap={false}>
            {title}
          </Typography>
        )}
        {children && (
          <Typography className={classes.tooltipContent} variant="body1" component={'div'} noWrap={false}>
            {children}
          </Typography>
        )}
      </>
    )
  }
)
